var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.feedbackItems),function(item){return _c('FeedbackListItem',{key:item.id,attrs:{"item":item,"highlight":_vm.todo_entry_id === item.id}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }